export default __webpack_public_path__ + "static/logo-d4b4309be01e9981f84422d440783c13.svg";